export default "__VITE_ASSET__CpFaUFYT__"